const home = "/";
const termsandconditions = "/terms-and-conditions";

export {
  home,
  termsandconditions,
};
